/** IVA rate for Colombia */
const IVA_RATE = 0.19;

export function getPalommaPlusIvaBreakdown(priceInclIva: number) {
  const base = Math.round(priceInclIva / (1 + IVA_RATE));
  const iva = priceInclIva - base;
  return { base, iva };
}

export const PALOMMA_PLUS = {
  price: 9900,
  puntosColombia: 250,
  rewardAmount: 1_000_000,
  rewardInterval: 400,
  hasBonda: true,
  termsUrl:
    'https://docs.google.com/document/d/e/2PACX-1vTr5z8cHGgiPb6gL0PVQ1vBrw4mXHMJBAXbZtO7xuGyqFTZMYuV2-AiIIRUTeAmUl5glZzr022IaRdx/pub',
} as const;
